import React from "react";

// Styled components
import {
    StyledBodyCellContainer,
    StyledBodyCellContent,
} from './DataTable.styles';

interface DataTableBodyCellProps {
    noBorder?: boolean;
    align?: 'left' | 'center' | 'right';
    children: React.ReactNode;
    verticalAlign?: 'top' | 'middle';
}

const DataTableBodyCell: React.FC<DataTableBodyCellProps> = ({
    noBorder,
    align,
    children,
    verticalAlign = 'middle'
}) => {
    return (
        <StyledBodyCellContainer
            align={align}
            noBorder={noBorder}
            verticalAlign={verticalAlign}
        >
            <StyledBodyCellContent verticalAlign={verticalAlign}>
                {children}
            </StyledBodyCellContent>
        </StyledBodyCellContainer>
    );
};

export default DataTableBodyCell; 